// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import HwComboboxController from "@josefarias/hotwire_combobox";
application.register("hw-combobox", HwComboboxController);

import {
  Dropdown,
  Modal,
  Popover,
  Toggle,
  Slideover,
} from "tailwindcss-stimulus-components";
application.register("dropdown", Dropdown);
application.register("modal", Modal);
application.register("popover", Popover);
application.register("toggle", Toggle);
application.register("slideover", Slideover);

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import TabsController from "./tabs_controller";
application.register("tabs", TabsController);

import MenuController from "./menu_controller";
application.register("menu", MenuController);

import NotificationsController from "./notifications_controller";
application.register("notifications", NotificationsController);

import ParameterizeController from "./parameterize_controller";
application.register("parameterize", ParameterizeController);

import ValidateController from "./validate_controller";
application.register("validate", ValidateController);

import NestedFormController from "./nested_form_controller";
application.register("nested-form", NestedFormController);

import ReorderController from "./reorder_controller";
application.register("reorder", ReorderController);

import toggled_controller from "./toggled_controller";
application.register("toggled", toggled_controller);

import asset_editor_controller from "./asset_editor_controller";
application.register("asset-editor", asset_editor_controller);

import picker_controller from "./picker_controller";
application.register("picker", picker_controller);

import video_controller from "./video_controller";
application.register("video", video_controller);

import new_template_controller from "./new_template_controller";
application.register("new-template", new_template_controller);

import template_editor_controller from "./template_editor_controller";
application.register("template-editor", template_editor_controller);

import clipboard_controller from "./clipboard_controller";
application.register("clipboard", clipboard_controller);

import gallery_picker_controller from "./gallery_picker_controller";
application.register("gallery-picker", gallery_picker_controller);

import gallery_select_controller from "./gallery_select_controller";
application.register("gallery-select", gallery_select_controller);

import filter_controller from "./filter_controller";
application.register("filter", filter_controller);

import collection_filter_controller from "./collection_filter_controller";
application.register("collection-filter", collection_filter_controller);

import content_transfer_controller from "./content_transfer_controller";
application.register("content-transfer", content_transfer_controller);

import direct_upload_form_controller from "./direct_upload_form_controller";
application.register("direct-upload-form", direct_upload_form_controller);

import dynamic_blueprints_controller from "./dynamic_blueprints_controller";
application.register("dynamic-blueprints", dynamic_blueprints_controller);

import auto_submit_controller from "./auto_submit_controller";
application.register("auto-submit", auto_submit_controller);

import remove_controller from "./remove_controller";
application.register("remove", remove_controller);

import PricingController from "./pricing_controller";
application.register("pricing", PricingController);

import StripeEmbeddedCheckoutController from "./stripe/embedded_checkout_controller";
application.register("stripe--embedded-checkout", StripeEmbeddedCheckoutController);

import CommandPaletteController from "./command_palette_controller";
application.register("command-palette", CommandPaletteController);

import CreatorController from "./creator_controller";
application.register("creator", CreatorController);

import CreatorProvisionController from "./creator_provision_controller";
application.register("creator-provision", CreatorProvisionController);

import RepoDropController from "./repo_drop_controller";
application.register("repo-drop", RepoDropController);

import ChatScrollController from "./chat_scroll_controller";
application.register("chat-scroll", ChatScrollController);

import TextareaAutogrowController from "./textarea_autogrow_controller";
application.register("textarea-autogrow", TextareaAutogrowController);
